// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"e6c3e558","453":"eca5f793","800":"1b0aa104"}[chunkId] + ".chunk.js";
};